module.exports = __webpack_public_path__ + "static/media/facebook.57e77b60.svg";